<app-toolbar *ngIf="isAuthenticated$ | async"></app-toolbar>
<div class="container">
    <mat-sidenav-container>
        <mat-sidenav mode="side" [opened]="isAuthenticated$ | async">
            <app-sidenav></app-sidenav>
        </mat-sidenav>
        <mat-sidenav-content>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
